export type Pattern = Array<string>;

export const Patterns: { [index: string]: Pattern } = {
  Acorn: [
    " X",
    "   X",
    "XX  XXX",
  ],

  BHepto: [
    " X",
    "XXX",
    "X XX",
  ],

  Blinker: [
    "XXX"
  ],

  Exploder: [
    "X X X",
    "X   X",
    "X   X",
    "X   X",
    "X X X",
  ],

  Glider: [
    " X",
    "  X",
    "XXX",
  ],

  PiHepto: [
    "XXX",
    "X X",
    "X X",
  ],

  Pulsar: [
    " XXX   XXX",
    "X   X X   X",
    "X   X X   X",
    "X   X X   X",
    " XXX   XXX",
    "",
    " XXX   XXX",
    "X   X X   X",
    "X   X X   X",
    "X   X X   X",
    " XXX   XXX",
  ],

  Rabbits: [
    "X   XXX",
    "XXX  X",
    " X",
  ],

  RPento: [
    " XX",
    "XX",
    " X",
  ],

  SmallExploder: [
    " X",
    "XXX",
    "X X",
    " X",
  ],

  Spaceship: [
    "XXXX",
    "X   X",
    "X",
    " X  X",
  ],

  TenCellRow: [
    "XXXXXXXXXX",
  ],

  Toad: [
    "XXX",
    " XXX",
  ],

};

export default Patterns;



// WEBPACK FOOTER //
// ./src/common/patterns/index.ts